export default "__VITE_ASSET__536821a4__"